module.exports = __webpack_public_path__ + "static/media/4.bd901585.webp";